<template>
  <div class="register">
    <el-form
      ref="registerForm"
      :model="registerForm"
      :rules="registerRules"
      class="register-form"
    >
      <h3 class="title">版灯-DCI数字版权登记平台</h3>
      <el-form-item prop="username" >
        <el-input
          v-model="registerForm.username"
          type="text"
          auto-complete="off"
          placeholder="账号"
        >
          <svg-icon
            slot="prefix"
            icon-class="user"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="phoneNum">
        <el-input
          v-model="registerForm.phoneNum"
          type="text"
          auto-complete="off"
          placeholder="手机号码"
        >
          <svg-icon
            slot="prefix"
            icon-class="user"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="registerForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleRegister"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input
          v-model="registerForm.confirmPassword"
          type="password"
          auto-complete="off"
          placeholder="确认密码"
          @keyup.enter.native="handleRegister"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
          v-model="registerForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleRegister"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="register-code">
          <img :src="codeUrl" @click="getCode" class="register-code-img" />
        </div>
      </el-form-item>
      <el-form-item prop="verificationCode" v-if="captchaEnabled">
        <el-input
          v-model="registerForm.verificationCode"
          auto-complete="off"
          placeholder="短信验证码"
          style="width: 63%"
          @keyup.enter.native="handleRegister"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="register-code">
          <el-button @click.native="getVerificationCode" :disabled="isDisabled">
            {{ buttonText }}</el-button
          >
        </div>
      </el-form-item>
      <div class="agreement-row">
        <el-checkbox v-model="registerForm.agreePolicy">
          <span>勾选代表同意</span>
          <button
            type="button"
            class="agreement-link"
            @click.stop.prevent="openLegal"
          >
            《用户协议和隐私政策》
          </button>
        </el-checkbox>
      </div>
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleRegister"
        >
          <span v-if="!loading">注 册</span>
          <span v-else>注 册 中...</span>
        </el-button>
        <div style="float: right">
          <router-link class="link-type" :to="'/login'"
            >使用已有账户登录</router-link
          >
        </div>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-register-footer">
      <span>Copyright©2024-2026中版知识产权代理（重庆）有限公司所有</span>
    </div>
  </div>
</template>

<script>
import { getCodeImg, register, getVerificationCode } from "@/api/login";

export default {
  name: "Register",
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.registerForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      codeUrl: "",
      registerForm: {
        username: "",
        password: "",
        confirmPassword: "",
        code: "",
        verificationCode: "",
        phoneNum: "",
        uuid: "",
        agreePolicy: false,
      },
      registerRules: {
        username: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        phoneNum: [
          { required: !0, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 5,
            max: 20,
            message: "用户密码长度必须介于 5 和 20 之间",
            trigger: "blur",
          },
          {
            pattern: /^[^<>"'|\\]+$/,
            message: "不能包含非法字符：< > \" ' \\\ |",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
        verificationCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
      },
      loading: false,
      captchaEnabled: true,
      isDisabled: false, // 按钮是否禁用
      countdown: 60, // 倒计时时间
      buttonText: "获取验证码", // 按钮文本
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.registerForm.uuid = res.uuid;
        }
      });
    },
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (!this.registerForm.agreePolicy) {
            this.$message.warning("请先阅读并勾选用户协议和隐私政策");
            return;
          }

          this.loading = true;
          register({
            username: this.registerForm.username,
            password: this.registerForm.password,
            phoneNum: this.registerForm.phoneNum,
            code: this.registerForm.verificationCode,
          })
            .then((res) => {
              const username = this.registerForm.username;
              this.$alert(
                "<font color='red'>恭喜你，您的账号 " +
                  username +
                  " 注册成功！</font>",
                "系统提示",
                {
                  dangerouslyUseHTMLString: true,
                  type: "success",
                }
              )
                .then(() => {
                  this.$router.push("/login");
                })
                .catch(() => {});
            })
            .catch(() => {
              this.loading = false;
              if (this.captchaEnabled) {
                this.getCode();
              }
            });
        }
      });
    },
    openLegal() {
      const route = this.$router.resolve({ path: "/legal" });
      window.open(route.href, "_blank");
    },
    async getVerificationCode() {
      if (this.registerForm.code) {
        //         /sms/temp/{type}
        // String phone 手机号
        // String captchaUuid 图形验证码id
        // String captchaCode 图形验证码用户填写值
        // 这个是发送短信的接口，type固定值reg、login、dci，分别对应注册、登录、dci申领支付
        let upbadge = new FormData();
        upbadge.append("phone", this.registerForm.phoneNum);
        upbadge.append("captchaUuid", this.registerForm.uuid);
        upbadge.append("captchaCode", this.registerForm.code);
        const res = await getVerificationCode(upbadge, "reg");
        if (res.code == 200) {
          this.$message({
            message: "验证码已发送",
            type: "success",
          });
          // 禁用按钮
          this.isDisabled = true;
          // 启动倒计时
          const timer = setInterval(() => {
            this.countdown--;
            this.buttonText = `${this.countdown}秒后重试`;

            // 倒计时结束
            if (this.countdown <= 0) {
              clearInterval(timer); // 清除定时器
              this.isDisabled = false; // 启用按钮
              this.buttonText = "获取验证码"; // 恢复按钮文本
              this.countdown = 60; // 重置倒计时时间
            }
          }, 1000);
        }
        console.log("短信验证码--------", res);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/images/login-background.jpg");
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
  font-weight: bold;
  font-size: 20px;
  line-height: 1;
}

.register-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.register-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.register-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-register-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.register-code-img {
  height: 38px;
}

.agreement-row {
  margin: 0 0 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-row .el-checkbox {
  display: flex;
  align-items: center;
  white-space: normal;
}

.agreement-row .el-checkbox__label {
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-link:hover {
  color: #66b1ff;
}
</style>
